module.exports = __webpack_public_path__ + "static/media/email.a177e68c.svg";